{
  "title": "Welcome",
  "loading": "Loading...",
  "folderView": {
    "title": "Inbox"
  },
  "folderActions": {
    "applyAll": "Copy to all subfolders",
    "applySelected": "Copy to selected subfolders"
  },
  "misc": {
    "logout": "Sign out",
    "login": "Sign in",
    "close": "Close"
  },
  "license": {
    "dialog": {
      "title": "License Info",
      "client": "Client",
      "domains": "Domains",
      "type": " License Typ",
      "expiry": "Expiry Date",
      "productGuid": "Product ID"
    },
    "invalid": "No valid license. Please contact your system administrator."
  },
  "permissions": {
    "isLoading": "Folder is loading...",
    "displayErrorDetails": "Display Error Details",
    "errors": {
      "couldNotLoadError": "Could not load Folder",
      "missingExchangeFolderId": "This link is incomplete. Please select the folder again in the folder list."
    },
    "user": "User",
    "permissionLevel": "Permission level",
    "checkLabel": "Yes",
    "uncheckLabel": "No",
    "sortAscLabel": "Sort ascending",
    "sortDescLabel": "Sort descending",
    "unsortedLabel": "Do not sort",
    "createPermissions": "Create",
    "createPermissionsNone": "None",
    "createPermissionsItems": "Items",
    "createPermissionsSubfolders": "Subfolders",
    "createPermissionsItemsSubfolders": "Items + subfolders",
    "readPermissions": "Read",
    "readPermissionsNone": "None",
    "readPermissionsFull": "Full details",
    "editPermissions": "Edit",
    "editPermissionsNone": "None",
    "editPermissionsOwn": "Own",
    "editPermissionsAll": "All",
    "deletePermissions": "Delete",
    "folderPermissions": "Folder permissions",
    "folderPermissionsNone": "None",
    "isFolderOwner": "Owner",
    "isFolderVisible": "Visible",
    "isFolderContact": "Contact",
    "modifyAction": {
      "editTitle": "Edit",
      "addTitle": "Add permissions",
      "closeButton": "Cancel",
      "submitButton": "Apply",
      "applyRecursive": "Apply to all subfolders",
      "personGroup": {
        "label": "Person",
        "noItems": "No persons found",
        "alreadySelected": "- already selected"
      },
      "levelGroup": {
        "label": "Permission level",
        "options": {
          "owner": "Owner",
          "publishingEditor": "Publishing editor",
          "editor": "Editor",
          "publishingAuthor": "Publishing author",
          "author": "Author",
          "noneditingAuthor": "Nonediting author",
          "reviewer": "Reviewer",
          "contributor": "Contributor",
          "none": "None",
          "custom": "Custom"
        },
        "warnings": {
          "owner": "Owners of the selected permission level can grant permissions to other users and may revoke your permissions."
        }
      },
      "readGroup": {
        "label": "Read",
        "options": {
          "none": "None",
          "full": "Full details"
        }
      },
      "deleteGroup": {
        "label": "Delete",
        "options": {
          "none": "None",
          "own": "Own",
          "all": "All"
        }
      },
      "editGroup": {
        "label": "Edit",
        "options": {
          "none": "None",
          "own": "Own",
          "all": "All"
        }
      },
      "createGroup": {
        "label": "Create",
        "options": {
          "createItems": "Items",
          "createSubfolders": "Subfolders"
        }
      },
      "otherGroup": {
        "label": "Other",
        "options": {
          "folderOwner": "Folder owner",
          "folderContact": "Folder contact",
          "folderVisible": "Folder visible"
        }
      }
    },
    "actionsColumnTitle": "Actions",
    "deleteAction": {
      "buttonLabel": "Delete",
      "cancelLabel": "Cancel",
      "confirmTitle": "Do you really want to delete the permission?"
    },
    "pagination": {
      "nextLabel": "Next",
      "previousLabel": "Previous",
      "currentLabel": "Page "
    }
  },
  "toast": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Info",
    "copy": "Copy to clipboard",
    "dismiss": "Dismiss",
    "unknownError": "Unknown error",
    "traceId": "Trace ID",
    "timestamp": "Timestamp"
  },
  "placeholder": {
    "iconText": "Select a folder",
    "description": "Choose a folder from the overview to view or change its permissions."
  },
  "peoplePicker": {
    "errors": {
      "anErrorOccurred": "An error occurred"
    }
  },
  "rootErrorComponent": {
    "unknownError": {
      "title": "Unknown Error",
      "description": "An unexpected error has occurred. Please try again later."
    },
    "backendOfflineError": {
      "title": "Backend Unavailable",
      "description": "We're currently unable to connect to the server."
    },
    "retryButtonLabel": "Retry"
  }
}